import * as React from "react";

import AppModals from "@editor/components/AppModals";
import { DebugModal } from "@editor/components/editor/debug/DebugPanel";
import { useCurrentProjectContext } from "@editor/contexts/CurrentProjectContext";
import { useReploHotkeys } from "@editor/hooks/useHotkeys";
import { useEditorDispatch, useEditorSelector } from "@editor/store";
import {
  selectInternalDebugModeOn,
  setDebugPanelVisibility,
} from "@reducers/core-reducer";

import { ProjectWebsocketProvider } from "@/features/react-editor/components/ProjectWebsocketProvider";
import { Outlet } from "react-router-dom";

import ReactEditorNavbar from "../components/navbar/ReactEditorNavbar";

export default function ReactEditorLayout() {
  const dispatch = useEditorDispatch();
  const isDebugPanelVisible = useEditorSelector(selectInternalDebugModeOn);

  const toggleDebugMode = React.useCallback(() => {
    dispatch(setDebugPanelVisibility(!isDebugPanelVisible));
  }, [dispatch, isDebugPanelVisible]);

  useReploHotkeys({ debug: toggleDebugMode });

  const { project } = useCurrentProjectContext();
  return (
    <ProjectWebsocketProvider projectId={project?.id ?? ""}>
      <div className="flex h-screen flex-col">
        {isDebugPanelVisible && <DebugModal />}

        <div className="w-full h-full flex flex-col bg-white p-3 overflow-hidden">
          <div className="flex flex-col gap-3 w-full h-full">
            <ReactEditorNavbar />
            <div className="flex-1 min-h-0">
              <AppModals />
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </ProjectWebsocketProvider>
  );
}
